import axios from "axios";
import jsonp from "jsonp-promise";
import { Singleton } from "util";
import BaseService from "./base.service";
import { ApiResourceBuilder } from "core/builder";

@Singleton
class CompanyService extends BaseService {
  async getCnpjInfo(cnpj) {
    try {
      const cnpjResponse = await jsonp(
        `https://www.receitaws.com.br/v1/cnpj/${cnpj}`
      ).promise;

      if (cnpjResponse) {
        const response = {
          success: true,
          email: cnpjResponse.email,
          tradingName: cnpjResponse.fantasia,
          name: cnpjResponse.nome,
          phonenumber: cnpjResponse.telefone,

          zipcode: cnpjResponse.cep.replace(/\D/g, ""),
          addressAdditional:
            cnpjResponse.complemento.length === 0
              ? "S/C"
              : cnpjResponse.complemento,
          state: cnpjResponse.uf,
          address: cnpjResponse.logradouro,
          neighborhood: cnpjResponse.bairro,
          city: cnpjResponse.municipio,
          addressNumber: cnpjResponse.numero
        };

        const zipcodeInfo = await this.getZipcodeInfo(response.zipcode);
        if (zipcodeInfo.success) {
          response.cityCode = zipcodeInfo.cityCode;
        }

        return response;
      }
    } catch (e) {
      // DO NOTHING
    }

    return { success: false };
  }

  async getZipcodeInfo(zipcode) {
    try {
      const cepResponse = await axios.get(
        `https://viacep.com.br/ws/${zipcode}/json/`
      );

      if (cepResponse && cepResponse.data) {
        return {
          success: true,
          neighborhood: cepResponse.data.bairro,
          address: cepResponse.data.logradouro,
          city: cepResponse.data.localidade,
          state: cepResponse.data.uf,
          cityCode: cepResponse.data.ibge,
          addressAdditional: cepResponse.data.complemento
        };
      }
    } catch (e) {
      // DO NOTHING
    }

    return { success: false };
  }

  async fetch(_companyUuid, { filters, order, pagination }) {
    const url = `/v1/companies`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      filters,
      order,
      pagination
    });
    return await this.get(resourceRoute);
  }

  async fetchByUuid(_companyUuid, uuid) {
    return await this.get(`/v1/companies/${uuid}`);
  }

  async importCompanies(params) {
    return await this.post(`/v1/companies/import`, params);
  }

  async toggleBlockCompanies(params) {
    let response, success;
    try {
      response = await axios.post(
        `${process.env.REACT_APP_MONGO_WH_COMPANY}?env=${process.env.REACT_APP_ENV}&secret=${process.env.REACT_APP_MONGO_WH_COMPANY_SECRET}`,
        params
      );
      success = true;
    } catch (e) {
      if (e instanceof axios.Cancel) {
        e.response = {
          ...(e.response || {}),
          data: { error: { userCancelled: true } }
        };
      }
      response = e.response;
      success = false;
    }

    const fatal = !response || response.status >= 500;
    const status = response ? response.status : 400;
    const data = fatal ? null : response.data;
    const headers = fatal ? null : response.headers;
    const errors =
      !!response && !!response.data.errors ? response.data.errors : [];

    return { fatal, status, data, headers, success, errors };
  }

  // DEPRECATED: Use fetch instead
  async getCompanies({ filters, order, pagination }) {
    const resourceRoute = ApiResourceBuilder.buildFromParams("/v1/companies", {
      filters,
      order,
      pagination
    });
    return await this.get(resourceRoute);
  }

  async update(_companyUuid, uuid, params) {
    return await super.update(`/v1/companies/${uuid}`, params);
  }

  async create(_companyUuid, params) {
    return await this.post(`/v1/companies`, params);
  }

  async validateInfo(company_uuid) {
    return await this.get(`/proxy/validate/company/${company_uuid}`);
  }

  async validateSellables(company_uuid) {
    return await this.get(`/proxy/validate/sellables/${company_uuid}`);
  }

  async validateSellablesNfce(company_uuid) {
    return await this.get(`/proxy/validate/sellables/${company_uuid}/nfce`);
  }

  async cloneCompanySellables({ destination, origin }) {
    let response, success;
    try {
      response = await axios.post(
        `${process.env.REACT_APP_CLONE_SELLABLES_WH}?env=${process.env.REACT_APP_ENV}&secret=${process.env.REACT_APP_CLONE_SELLABLES_WH_SECRET}`,
        {
          origin,
          destination
        }
      );
      success = true;
    } catch (e) {
      if (e instanceof axios.Cancel) {
        e.response = {
          ...(e.response || {}),
          data: { error: { userCancelled: true } }
        };
      }
      response = e.response;
      success = false;
    }

    const fatal = !response || response.status >= 500 || response.data.fatal;
    const status = response ? response.status : 400;
    const data = fatal ? null : response.data;
    const headers = fatal ? null : response.headers;
    const errors =
      !!response && !!response.data.errors ? response.data.errors : [];

    return { fatal, status, data, headers, success, errors };
  }
}

export default CompanyService;



// WEBPACK FOOTER //
// ./src/core/service/company.service.js